require('./insuranceRequestWizardStep5.scss');
require('./insuranceRequestWizardStep5.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const InsuranceRequestPolicySummary = require('../insuranceRequestPolicySummary/insuranceRequestPolicySummary');
const { InsurancePdfViewer } = require('../insurancePdfViewer/insurancePdfViewer');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING,
} = require('components/contactCenter/confirmScript/confirmationScript');

// @ components ContactCenter
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

// @ constants
const { FOURTH_STEP, FIFTH_STEP } = require('constants/index');
const {
    DOCUMENT_TYPES,
    HOME_INSURANCE_CONFIRMATION_ID,
    HOME_INSURANCE_RELATED_CONFIRMATION_ID,
    wizardSimulationName,
} = require('../../../insuranceConstants/insuranceRequestHome');
const { INSURANCE_SUMMARY, INSURANCE_SUMMARY_RELATED, INSURANCE_SUMMARY_RNC } = wizardSimulationName;
const {
    INSURANCES_OBLIGATIONS_DOCUMENT,
    INSURANCE_USABILITY_IMPROVEMENTS,
    INSURANCE_IDD_REGULATION,
} = require('constants/flagBasedFeatures');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

const { VIEWER } = require('constants/contactCenter/pdfViewer');

class InsuranceRequestWizardStep5 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            conditionsCheck: false,
            showModal: false
        };

        this.handleConditionsCheck = this.handleConditionsCheck.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    componentWillMount() {
        const {
            immInsuranceWizardPrevStep,
            resetPrecontractualMail,
            getPaymentAccount,
            isRnc,
            setData
        } = this.props;

        if (!immInsuranceWizardPrevStep.get('accountId') && !isRnc) {
            getPaymentAccount();
        }

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
            setData(FIFTH_STEP, {
                agreementChecked: false,
                valid: false,
                validUI: false,
                fieldErrors: false
            });
        }
    }

    componentDidMount() {
        const {
            getAddressTypeList,
            isRelated,
            getDocumentsSummary,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            getDocumentsSummary(this.wizardName());
        }

        if (!isRelated) {
            getAddressTypeList();
        }
    }

    componentWillUnmount() {
        const { setData, isRnc, immInsuranceWizardStep } = this.props;

        const currentStep = isRnc ? FOURTH_STEP : FIFTH_STEP

        setData(currentStep, {
            acceptedConditions: __CONTACT_CENTER__ ? immInsuranceWizardStep.get('acceptedConditions') : false,
            summary: null
        });
    }

    handleConditionsCheck(evt) {
        const { setData, isRnc } = this.props;
        const currentStep = isRnc ? FOURTH_STEP : FIFTH_STEP;
        setData(currentStep, { acceptedConditions: evt.target.checked })
    }

    handleToggleModal() {
        this.setState({ showModal: !this.state.showModal })
    }

    handleDocumentDownload(evt, docType, docName, loadType) {
        const { getDocument } = this.props;
        evt.preventDefault();
        getDocument(docType, docName, loadType)
    }

    buildConditions() {
        const poeditorPrefix = 'insuranceRequestHome';

        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${key}`;
        };

        const splitMessage = formatText(getPoEditorKey(`${poeditorPrefix}_insuranceConditionsLabelWeb`)).split('%s');

        const injectedLinks = [
            { docType: DOCUMENT_TYPES.BUDGET, text: getPoEditorKey('step5LinkBudget') },
            { docType: DOCUMENT_TYPES.PRODUCT_INFORMATION, text: getPoEditorKey('step5LinkProductInformation') },
            { docType: DOCUMENT_TYPES.DOCUMENT_CONDITIONS, text: getPoEditorKey('step5LinkDocumentConditions') },
            { docType: DOCUMENT_TYPES.INFORMATIVE_NOTE, text: getPoEditorKey('step5LinkMediator') },
        ];

        const message = splitMessage.map((message, index) => {
            const documentName = injectedLinks[index] ? (formatText(injectedLinks[index].text)) : '';
            const replacement = injectedLinks[index] ? (
                <OKButton
                    onClick={evt => this.handleDocumentDownload(evt, injectedLinks[index].docType, documentName)}
                    modifier="link-emphasize"
                    autoHeight
                    loading={false}
                >
                    {documentName}
                </OKButton>
            ) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }

    buildPoEditorKey(key) {
        const { isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHomeCC';
        return isRelated
            ? `${poeditorPrefix}-${poeditorPrefix}_${key}Related`
            : `${poeditorPrefix}-${poeditorPrefix}_${key}`;
    }

    buildHomeMixedMessage() {
        const { immFlagBasedFeatures } = this.props;
        const POE_KEY_CC = 'insuranceRequestHome-insuranceRequestHome_step5HomeMixedCC';
        const POE_KEY_WEB = 'insuranceRequestHome-insuranceRequestHome_step5HomeMixedPrivate';
        let poeKey;

        if (immFlagBasedFeatures.get(INSURANCE_IDD_REGULATION)) {
            poeKey = __CONTACT_CENTER__ ? POE_KEY_CC : POE_KEY_WEB;
        }

        return !!poeKey && (
            <p className="home-mixed">
                <FormattedText value={poeKey} />
            </p>
        )
    }
    buildCCConditions() {
        const splitMessage = formatText(this.buildPoEditorKey('step5Conditions')).split('%s');
        const injectedLinks = [
            { docType: DOCUMENT_TYPES.INFORMATIVE_NOTE, text: this.buildPoEditorKey('step5LinkMediator') },
            { docType: DOCUMENT_TYPES.BUDGET, text: this.buildPoEditorKey('step5LinkBudget') },
            { docType: DOCUMENT_TYPES.PRODUCT_INFORMATION, text: this.buildPoEditorKey('step5LinkProductInformation') },
            { docType: DOCUMENT_TYPES.DOCUMENT_CONDITIONS, text: this.buildPoEditorKey('step5LinkDocumentConditions') },
        ];

        const message = splitMessage.map((message, index) => {
            const documentName = injectedLinks[index] ? injectedLinks[index].text : '';
            const replacement = injectedLinks[index] ? (
                <OKButton
                    onClick={evt => this.handleDocumentDownload(evt, injectedLinks[index].docType, documentName, VIEWER)}
                    modifier="link-emphasize"
                    autoHeight={true}
                    loading={false}
                >
                    {formatText(documentName)}
                </OKButton>
            ) : '';
            return (
                <span key={index}>
                    <HTMLSafeInjector
                        message={message}
                        inline
                    />
                    {replacement}
                </span>
            );
        });
        return <span>{message}</span>;
    }
    buildPdfViewer() {
        const {
            immInsuranceWizardStep,
            onPrintDocument,
            getDocumentsZip,
            immInsuranceLegalDocuments,
            getDocumentsSummary,
            checkReadDocument
        } = this.props;

        const isFetchingForPreview = immInsuranceWizardStep.get('isFetchingForPreview');
        const acceptedConditions = immInsuranceWizardStep.get('acceptedConditions');
        const isFetchingSummary = immInsuranceLegalDocuments.get('isFetchingSummary');
        const summary = immInsuranceLegalDocuments.getIn([this.wizardName(), 'base64string']);
        const summaryError = immInsuranceLegalDocuments.get('summaryError');
        const isFetchingZip = immInsuranceLegalDocuments.get('isFetchingZip');
        const step5DocumentTitle = formatText('insuranceRequestHome-step5DocumentTitle');
        const documentRead = immInsuranceWizardStep.get('documentRead'); 

        return (
            <div className="row">
                <div className="col-xs-12">
                    <InsurancePdfViewer
                        agreeCheckbox={acceptedConditions}
                        checkboxLabel={this.buildConditions()}
                        document={summary}
                        errorLoading={summaryError}
                        getDocuments={() => getDocumentsSummary(this.wizardName())}
                        hasSignaturePattern
                        isLoading={isFetchingSummary}
                        loadingDownload={isFetchingZip}
                        onAgreeCheckbox={this.handleConditionsCheck}
                        onDownload={() => getDocumentsZip(this.wizardName())}
                        onPrint={() => onPrintDocument(this.wizardName())}
                        title={step5DocumentTitle}
                        isFetchingForPreview={isFetchingForPreview}
                        checkReadDocument={checkReadDocument}
                        documentRead={documentRead}
                    />
                </div>
            </div>
        );
    }

    validateAcceptedTerms() {
        const { immInsuranceWizardStep } = this.props;
        const acceptedConditions = immInsuranceWizardStep.get('acceptedConditions');
        const nonAcceptedConditions = immInsuranceWizardStep.get('fieldErrors');
        const agreementChecked = immInsuranceWizardStep.get('agreementChecked');
        const messageAcceptancevalidation = formatText('insuranceRequestWizardSetp5-acceptanceMandatory');
        let showAcceptanceIssue = null;

        const agreeConditions = __CONTACT_CENTER__
            ? nonAcceptedConditions && !agreementChecked
            : !acceptedConditions && nonAcceptedConditions;

        if (agreeConditions) {
            showAcceptanceIssue = (
                <div className="insurance-request-wizard-step-five__box-issue-message">
                    <span className="insurance-request-wizard-step-five__box-issue-message-text">{messageAcceptancevalidation}</span>
                </div>
            )
        }

        return showAcceptanceIssue;
    }

    buildError() {
        return (
            <div className="row">
                <div className="col-xs-12 insurance-request-wizard-step-five__field-errors-message">
                    <OKMessage type="warning">
                        <FormattedText value="insuranceRequestHome-stepValidationError" />
                    </OKMessage>
                </div>
            </div>
        );
    }

    wizardName() {
        const { isRelated, isRnc } = this.props;
        let wizardName = INSURANCE_SUMMARY;
        if (isRelated) {
            wizardName = isRnc ? INSURANCE_SUMMARY_RNC : INSURANCE_SUMMARY_RELATED;
        }
        return wizardName;
    }

    buildLegalConfirmationSection() {
        const {
            handleAgreementCheckboxChange,
            immInsuranceWizardStep,
            immPreContractualMail,
            immProfile,
            requestProfile,
            sendMailParams,
            sendPreContractualMail,
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const agreementChecked = immInsuranceWizardStep.get('agreementChecked');
        const profileError = immProfile.get('error');

        // Check
        const acceptanceValidation = this.validateAcceptedTerms();
        const conditionsText = this.buildCCConditions();
        const nonAcceptedConditions = immInsuranceWizardStep.get('fieldErrors') && !agreementChecked;
        const boxClassName = classnames("insurance-request-wizard-step-five__box-conditions", {
            "insurance-request-wizard-step-five__box-issue": nonAcceptedConditions
        });
        return (
            <section className="insurance-request-wizard-step-five__precontract">
                <PreContractualMailInfo
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                    showLegalText={false}
                />
                <div>
                    <div className={boxClassName}>
                        <BlockInfo
                            extraClass={'insurance-request-wizard-step-five__block-info'}
                            hasCheckbox>
                            {<OKCheckbox
                                idName="acceptConditionsCheck"
                                disabled={!hasBeenEmailSent}
                                onChange={handleAgreementCheckboxChange}
                                label={conditionsText}
                                value={agreementChecked}
                            />}
                        </BlockInfo>
                        {acceptanceValidation}
                    </div>
                </div>
            </section>
        );
    }

    buildPrintableZone(isPrintable) {
        const {
            contractName,
            hasSimulation,
            hasSimulationChanged,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardState,
            immInsuranceWizardStep,
            insuranceRelatedOtpOption,
            isPostAppraisal,
            isRelated,
            isRnc,
        } = this.props;
        const acceptedConditions = immInsuranceWizardStep.get('acceptedConditions');
        const step5CheckData = isRelated ? 'insuranceRelatedRequest-step5CheckData' : 'insuranceRequestHome-step5CheckData';
        const nonAcceptedConditions = immInsuranceWizardStep.get('fieldErrors') && !acceptedConditions;
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const isRelatedAndOtpOptionIsOn = isRelated && insuranceRelatedOtpOption;

        const oKConsentsGdpr = !isRnc && !isRelatedAndOtpOptionIsOn && (
            <div className="row">
                <div className="col-xs-12 insurance-request-wizard-step-five__gdpr-consents">
                    <div className="col-xs-12 insurance-request-wizard-step-five__gdpr-consents-separator"></div>
                    <OKConsents placementId="insurances-step5" />
                </div>
            </div>
        );

        const confirmationScript = (
            <ContactCenterRender>
                <ConfirmationScript
                    operative={formatText(contractName)}
                    confirmationType={CONFIRMATION_SCRIPT_GREETING}
                />
            </ContactCenterRender>
        );

        const policySummary = (
            <InsuranceRequestPolicySummary
                isRelated={isRelated}
                immInsuranceState={immInsuranceState}
                immInsuranceWizardState={immInsuranceWizardState}
                immAccounts={immAccounts}
                hasSimulation={hasSimulation}
                hasSimulationChanged={hasSimulationChanged}
                isRnc={isRnc}
                isPostAppraisal={isPostAppraisal}
            />
        );

        const printableZone = (
            <div id="printable-wizard" className="insurance-request-wizard-step-five__only-printable">
                <div className="row">
                    <header className="col-xs-12 insurance-request-wizard-step-five__header">
                        {confirmationScript}
                    </header>
                </div>
                {nonAcceptedConditions && this.buildError()}
                <div className="row">
                    <div className="col-xs-12 insurance-request-wizard-step-five__text">
                        <FormattedText value={step5CheckData} />
                    </div>
                </div>
                {policySummary}
                {oKConsentsGdpr}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
            </div>
        );

        const viewZone = (
            <React.Fragment>
                <div className="row">
                    <header className="col-xs-12 insurance-request-wizard-step-five__header">
                        {confirmationScript}
                        <FormattedText value="insuranceRequestHome-step5Title" />
                    </header>
                </div>
                {nonAcceptedConditions && this.buildError()}
                <div className="row">
                    <div className="col-xs-12 insurance-request-wizard-step-five__text">
                        <FormattedText value={step5CheckData} />
                    </div>
                </div>
                {policySummary}
                <OKMessage
                    type="informative"
                    visible={!!isInsuranceUsabilityImprovementsEnabled}
                >
                    <FormattedText value="insuranceRequestHome-insuranceRequestHome_step5NoVeracityOnData" />
                    {this.buildHomeMixedMessage()}
                </OKMessage>
                {oKConsentsGdpr}
            </React.Fragment>
        );

        return isPrintable ? printableZone : viewZone;
    }

    informationDutyLink() {
        const { immFlagBasedFeatures, isRnc } = this.props;
        const informationDutyIsEnabled = !isRnc && immFlagBasedFeatures.get(INSURANCES_OBLIGATIONS_DOCUMENT);
        let informationDuty;
        if (informationDutyIsEnabled && isPrintOfficeMode()) {
            const informationDutyDocument = formatText(this.buildPoEditorKey('informationDutyDocument'));
            const informationDutyLink = formatText(this.buildPoEditorKey('informationDutyLink'));
            informationDuty = (
                <OKLink
                    to={informationDutyDocument}
                    target="_blank"
                    modifier="emphasize">
                    {informationDutyLink}
                </OKLink>
            );
        }

        return informationDuty;
    }

    render() {
        const {
            immAccounts,
            immInsuranceWizardPrevStep,
            immInsuranceWizardStep,
            insuranceRelatedOtpOption,
            isRelated,
            isRnc,
        } = this.props;

        if (!isRnc && immAccounts.get('isFetching') || immInsuranceWizardPrevStep.get('isFetchingAccount')) {
            return <LoadingSection />
        }
        const insurancePdfViewer = !__CONTACT_CENTER__ && this.buildPdfViewer();
        const acceptedConditions = immInsuranceWizardStep.get('acceptedConditions');
        const confirmationID = isRelated ? HOME_INSURANCE_RELATED_CONFIRMATION_ID : HOME_INSURANCE_CONFIRMATION_ID;
        const checkAgreementCheckFlag = __CONTACT_CENTER__ ? immInsuranceWizardStep.get('agreementChecked') : true;
        const isRelatedAndOtpOptionIsOn = isRelated && insuranceRelatedOtpOption;
        const otpSignature = !isRnc && !isRelatedAndOtpOptionIsOn && acceptedConditions && checkAgreementCheckFlag && (
            <div className="row insurance-request-wizard-step-five__otp-code">
                <GDPRSignaturePattern
                    operationType={confirmationID}
                    operationParams={{}}
                />
            </div>
        );

        const modalContent = (
            <React.Fragment>
                <p className="insurance-request-wizard-step-five__modal-text">
                    <FormattedText value="insuranceRequestHome-step5ModalSubtitle" />
                </p>
                <ul className="insurance-request-wizard-step-five__modal-list">
                    <li className="insurance-request-wizard-step-five__modal-list-item">
                        <span className="insurance-request-wizard-step-five__modal-bullet">1</span>
                        <FormattedText value="insuranceRequestHome-step5ModalOpenDocs" />
                    </li>
                    <li className="insurance-request-wizard-step-five__modal-list-item">
                        <span className="insurance-request-wizard-step-five__modal-bullet">2</span>
                        <FormattedText value="insuranceRequestHome-step5ModalAcceptConditions" />
                    </li>
                </ul>
            </React.Fragment>
        );

        const legalConfirmationSection = __CONTACT_CENTER__ && this.buildLegalConfirmationSection();

        return (
            <div className="insurance-request-wizard-step-five">
                {this.buildPrintableZone(true)}
                {this.buildPrintableZone(false)}
                {insurancePdfViewer}
                {legalConfirmationSection}
                {this.informationDutyLink()}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {otpSignature}
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleModal}
                    onPrimaryButtonClick={this.handleToggleModal}
                    primaryButtonText="insuranceRequestHome-step5Understood"
                    title="insuranceRequestHome-step5ModalTitle"
                />
            </div>
        );
    }
}

InsuranceRequestWizardStep5.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func,
    contractName: PropTypes.string,
    isRelated: PropTypes.bool,
    isRnc: PropTypes.bool.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    immInsuranceLegalDocuments: PropTypes.object.isRequired,
    immInsuranceWizardPrevStep: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getDocument: PropTypes.func.isRequired,
    getDocumentsSummary: PropTypes.func.isRequired,
    getPaymentAccount: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    getDocumentsZip: PropTypes.func.isRequired,
    getAddressTypeList: PropTypes.func,
    immInsuranceWizardState: PropTypes.object.isRequired,
    immInsuranceState: PropTypes.object.isRequired,
    hasSimulation: PropTypes.bool.isRequired,
    hasSimulationChanged: PropTypes.bool.isRequired,
    isPostAppraisal: PropTypes.bool.isRequired,
    immPreContractualMail: PropTypes.object,
    immProfile: PropTypes.object,
    requestProfile: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    insuranceRelatedOtpOption: PropTypes.bool,
    checkReadDocument: PropTypes.func,
};

InsuranceRequestWizardStep5.defaultProps = {
    isRelated: false,
    isRnc: false,
    isPostAppraisal: false
}

module.exports = InsuranceRequestWizardStep5;
